export default ['en', 'pt', 'ur', 'es', 'in', 'pa', 'ne', 'ir', 'ro', 'ru', 'te', 'cn', 'id', 'fr', 'ta', 'ka', "ar", "lg"]
